import { useUserInterfaceStore } from "../store";
import PlayerScene from "./Scene/PlayerScene";
import EditorScene from "./Scene/EditorScene";
import ErrorBoundary from "./ErrorBoundary";

function MainScene() {
  const playerMode = useUserInterfaceStore((s) => s.playerMode);
  const isEditing = playerMode === "editor";

  const handleSceneError = (error, errorInfo) => {
    console.error('MainScene error:', error, errorInfo);
    // Could send to error tracking service here
  };

  const handleRetry = () => {
    // Force a re-render by clearing any cached scene state if needed
    window.location.reload();
  };

  return (
    <ErrorBoundary
      onError={handleSceneError}
      title="3D Scene Loading Error"
      message="The 3D scene encountered an error while loading. This might be due to corrupted room data, model loading failures, or graphics driver issues."
      onRetry={handleRetry}
      onReset={() => window.location.href = "/"}
    >
      {isEditing ? <EditorScene /> : <PlayerScene />}
    </ErrorBoundary>
  );
}

export default MainScene;
